// –– 1
gsap.set('.co-main-product', { opacity: 0 });
gsap.to('.co-main-product', { 
  opacity: 1, 
  duration: 1,
  ease: "Power2.inOut"
});
// –– 2
gsap.set('.co-pdp-s2 .z-ani-o', { opacity: 0, y: 0 });
let cPS2T = gsap.timeline({ paused: true });
cPS2T.to('.co-pdp-s2 .z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 1
});
ScrollTrigger.create({
  trigger: ".co-pdp-s2",
  start: "top bottom",
  end: "bottom top",
  animation: cPS2T
});

// –– 3
const cPS3Swiper1 = new Swiper('.co-pdp-s3-top-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 400,
  loop: false,
  centeredSlides: false,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: true,
  // },
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.co-pdp-s3 .swiper-button-next',
    prevEl: '.co-pdp-s3 .swiper-button-prev',
  },
});
// –– 4
gsap.set('.co-home-s10 .z-ani-o', { opacity: 0, y: 40 });
let cHS10Tl1 = gsap.timeline({ paused: true });
cHS10Tl1.to('.co-home-s10 .z-ani-o', {
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
});
ScrollTrigger.create({
  trigger: '.co-home-s10',
  start: "40% bottom",
  end: "bottom top",
  animation: cHS10Tl1
});
const sec10Swiper = new Swiper('.co-home-s10-swiper', {
  pagination: false,
  watchOverflow: true,
  slidesPerView: 3,

  navigation: {
    nextEl: '.co-home-s10-swiper .swiper-button-next',
    prevEl: '.co-home-s10-swiper .swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    749: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 3,
    },
  },
});
// –– 6
//
gsap.set('.co-process-s3-frame .z-ani-o', { opacity: 0, y: 40 });
let cPS3Tl1 = gsap.timeline({ paused: true });
cPS3Tl1.to('.co-process-s3-frame .z-ani-o', {
  y: 0,
  scale: 1,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
}, "-=0.9");
ScrollTrigger.create({
  trigger: '.co-process-s3-frame .z-ani-o',
  start: "40% bottom",
  end: "bottom top",
  animation: cPS3Tl1
});
//Simple Accordion
var coAccItems = document.querySelectorAll(".co-process-s3-item--title");
var coAccItemsWrapp = document.querySelectorAll(".co-process-s3-item");
// console.log(coAccItems);
// coAccItems.slice(0, 3).classList.add('visible');
// Hide the next sibling element for each item (the content associated with the title)
coAccItems.forEach(function (groupItem, index) {
  var nextElement = groupItem.nextElementSibling;
  if (index === 0 || groupItem.classList.contains("active")) {
    groupItem.classList.add("active");
    nextElement.classList.add("active");

    gsap.to(nextElement, {
      height: "auto",
      duration: 0.3,
      ease: "power2.inOut",
    });
  } else {
    nextElement.classList.remove("active");
    gsap.to(nextElement, {
      height: 0,
      duration: 0.3,
      ease: "power2.inOut",
    });
  }
  // Add a click event listener to each item
  groupItem.addEventListener("click", function (e) {
    e.preventDefault();
    // Check if the parent element already has the 'active' class
    if (!this.classList.contains("active")) {
      // If not active, hide all other sections
      // coAccItems.forEach(function (otherAccItem, otherIndex) {
      //   otherAccItem.classList.remove("active");
      //   otherAccItem.nextElementSibling.classList.remove("active");

      //   gsap.to(otherAccItem.nextElementSibling, {
      //     height: 0,
      //     duration: 0.3,
      //     ease: "power2.inOut",
      //   });
      // });
      // Add 'active' class to the clicked item and show its content
      this.classList.add("active");
      nextElement.classList.add("active");
      gsap.to(nextElement, {
        height: "auto",
        duration: 0.3,
        ease: "power2.inOut",
      });
    } else {
      // remove 'active' if clicked on 'active'
      this.classList.remove("active");
      nextElement.classList.remove("active");
      gsap.to(nextElement, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut",
      });
    }
    // If already active, don't hide the content
  });
});
coAccItemsWrapp.forEach(function (item, index) {
  if (index >= 3) {
    item.classList.add('hidden');
  }
});
coBtnMore = document.querySelector('.co-process-s3-btn-more');
coBtnMore.addEventListener('click', function (e) {
  e.preventDefault();
  coAccItemsWrapp.forEach(function (item, index) {
    item.style.animationDelay = '0.1'+ index*10 +'s';
    item.classList.remove('hidden');
    item.classList.add('visible');
    coBtnMore.style.display = 'none';
  });
});